import { render, staticRenderFns } from "./message.vue?vue&type=template&id=f489d6be&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=f489d6be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489d6be",
  null
  
)

export default component.exports